import styled from '@emotion/styled';

import {
  Description,
  DescriptionWrapper,
  ImageBackground,
  ImageWrapper,
  Statement,
  StoryItemWrapper,
  Title,
} from './StoryItem.styled';
type Props = {};

const StoryItemSecond = (props: Props) => {
  return (
    <StoryItemWrapper>
      <ImageWrapper>
        <ImageBackground src='/images/storyImage_2.png' />
        <AnimationWrapper>
          <ImagePeople src='/images/people.png' />
        </AnimationWrapper>
        <ImageGummy src='/images/gummy_adult.gif' />
      </ImageWrapper>
      <DescriptionWrapper>
        <Title>Gummy Can be Humans?</Title>
        <Description>
          <Statement>
            새로운 공간에서 무엇이든 될 수 있는 행복한 꺼미는
          </Statement>
          <Statement>
            이곳저곳을 돌아다닌다. 우연히 들어간 거대한 타워
          </Statement>
          <Statement>
            다양한 사람들을 만나게 되고 ‘나도 사람 모습으로 변해볼까?’
          </Statement>
        </Description>
      </DescriptionWrapper>
    </StoryItemWrapper>
  );
};

const ImageGummy = styled.img`
  position: absolute;
  top: 156px;
  left: 100px;
  width: 139px;
  /* width: fit-content; */
  height: 134px;
  object-fit: contain;
`;

const AnimationWrapper = styled.div`
  position: absolute;
  overflow: hidden;
  top: 80px;
  left: 107px;
  width: 118px;
  height: 92px;
`;

const ImagePeople = styled.img`
  position: absolute;
  top: 10px;
  left: -122px;
  width: fit-content;
  height: fit-content;

  @keyframes moveBox {
    from {
      left: -120px;
    }
    to {
      left: 0px;
    }
  }
  animation: 5s linear infinite alternate moveBox;
`;

export default StoryItemSecond;
